import _ from 'lodash';

export default {
	totalSize_: state => {
		const { totalSize } = state.pagingInfo;
		return totalSize;
	},

	pageUnit_: state => {
		const { pageUnit } = state.pagingInfo;
		return pageUnit;
	},
	getStartAplcDd_: ({ searchParams }) => searchParams.startAplcDd,
	getEndAplcDd_: ({ searchParams }) => searchParams.endAplcDd,
	getStartDcsnDd_: ({ searchParams }) => searchParams.startDcsnDd,
	getEndDcsnDd_: ({ searchParams }) => searchParams.endDcsnDd,
	getPwaEndPartStdCst_: ({ roApcnPopUp }) => roApcnPopUp.pwaEndPartStdCst,
	resultFileList_({ fileList }) {
		return fileList;
	},
	//상태값
	getIsSaveFlag_({ isSaveFlag }) {
		return isSaveFlag;
	},
	//삭제시 컴포넌트 값 초기화
	getIsDelFlag_({ isDelPwaCompInitFlag }) {
		return isDelPwaCompInitFlag;
	},
	//삭제시 컴포넌트 값 초기화
	getIsDelFlag2_({ isDelPwaCompInitFlag2 }) {
		return isDelPwaCompInitFlag2;
	},
	chkListRoApprRows_: function (state) {
		// 그리드에서 체크박스로 선택한것중
		return state.selectedRoApcnList.filter(el => el.prcsRslt == '10' || el.prcsRslt == '20');
	},
	chkSaveRoApprRows_: function (state) {
		return state.selectedRoApcnList.filter(el => el.prcsStep == '10' || el.prcsStep == '20');
	}
};
